<div class="select-none truncate">
  <span>{{ suggestField.topLabel | capitalize }}</span>
  <span *ngIf="!!suggestField.modelFieldRef" class="ml-2">-</span>

  <span class="ml-2">{{ suggestField.partNodeLabel | capitalize }}</span>

  <span class="ml-2 font-semibold">{{
    suggestField.partFieldLabel | capitalize
  }}</span>

  <span class="text-s400" *ngIf="!!suggestField.connectionType">
    <span class="ml-[5px]">- {{ suggestField.connectionType }}</span>
  </span>
</div>
